import PropTypes from 'prop-types'

const ESTRELLAS_2 = 2
const ESTRELLAS_3 = 3
const ESTRELLAS_4 = 4
const ESTRELLAS_5 = 5

export const Estrellas = ({ calificacion = 0, handleStarClick }) => {
  return (
    <div className="rating">
      <div>
        {[1, ESTRELLAS_2, ESTRELLAS_3, ESTRELLAS_4, ESTRELLAS_5].map((estrella) => (
          <label
            key={estrella}
            className="star label"
            style={{
              cursor: 'pointer',
              color: calificacion >= estrella ? 'orange' : 'gray',
              fontSize: '35px'
            }}
            onClick={() => handleStarClick(estrella)}
          >
            <i className="fa fa-star"></i>
          </label>
        ))}
      </div>
    </div>
  )
}

Estrellas.propTypes = {
  calificacion: PropTypes.number,
  handleStarClick: PropTypes.func.isRequired
}
